import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

const stats = [
  { label: "收录热梗", value: site.counts.topics, icon: "ri-fire-line" },
  { label: "表情包素材", value: site.counts.memes, icon: "ri-emotion-laugh-line" },
  { label: "二创作者", value: site.counts.creators, icon: "ri-magic-line" },
  { label: "日均访问", value: site.counts.daily, icon: "ri-eye-line" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[680px]">
      <img
        src="https://readdy.ai/api/search-image?query=abstract%20dark%20charcoal%20background%20with%20bold%20playful%203D%20geometric%20shapes%20in%20coral%20orange%20sunflower%20yellow%20and%20lime%20green%2C%20energetic%20dynamic%20floating%20composition%2C%20cinematic%20studio%20lighting%2C%20high%20detail%2C%20negative%20space%20in%20the%20center&width=1600&height=900&seq=chigua-hero-main-01&orientation=landscape"
        alt="513吃瓜 热梗社区首屏背景，抽象彩色几何图形"
        title="513吃瓜 - 网络热梗 表情包 二创二改聚合"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="relative z-10 mx-auto w-full px-4 py-28 md:px-6 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-100/25 bg-background-50/10 px-3.5 py-1.5 font-label text-xs text-background-100 backdrop-blur-sm">
            <span className="flex h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
            今日已更新 12 条热梗后续
          </span>

          <h1 className="mt-6 font-heading text-5xl leading-tight text-background-50 md:text-7xl">
            513吃瓜
            <span className="mt-3 block text-2xl text-accent-400 md:text-4xl">追梗不迷路，吃瓜有后续</span>
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/85 md:text-lg">
            从爆火到过气，一个热梗的全过程都在这里。我们整理后续梗、表情包、二创二改与评论区神评，
            让你不用在十几个平台之间来回跳，刷一遍就懂整个瓜。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" aria-hidden="true"></i>
              进入热梗库
            </Link>
            <Link
              to="/memes"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/35 px-6 py-3.5 font-label text-sm text-background-50 backdrop-blur-sm transition-colors hover:border-accent-400 hover:text-accent-400"
            >
              <i className="ri-emotion-laugh-line text-base" aria-hidden="true"></i>
              存表情包
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-2 gap-6 border-t border-background-100/20 pt-8 sm:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="flex items-center gap-1.5 font-label text-xs text-background-100/60">
                  <i className={`${item.icon} text-sm text-accent-400`} aria-hidden="true"></i>
                  {item.label}
                </dt>
                <dd className="mt-1.5 font-heading text-2xl text-background-50 md:text-3xl">{item.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}